import Dashboard from "./dashboard.vue";

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/_dashboard/index.js